import { createApp } from 'vue'
import GLightbox from 'glightbox';

// Swiper
import { register } from 'swiper/element-bundle';
register();

import BlockMinitabs from './vue/BlockMinitabs.vue'
import BlockVideos from "./vue/BlockVideos.vue";

import Utils from "./general/utils.js";
import Header from "./components/header";
import HomeAnimation from "./components/home-animation";
import Animations from "./components/animations";

var utils = new Utils();
const header = new Header();
const homeAnimation = new HomeAnimation();
const animations = new Animations();

document.querySelectorAll('.js-minitabs').forEach((el) => {
    const app = createApp({
        components: {
            BlockMinitabs
        },
    });
    app.mount(el);
});

document.querySelectorAll('.js-blockVideos').forEach((el) => {
    const app = createApp({
        components: {
            BlockVideos
        },
    });
    app.mount(el);
});

// lightbox
const lightbox = GLightbox({
    // all links to youtube or vimeo
    selector: 'a[href*="youtube.com/watch"], a[href*="vimeo.com"], a[href*="youtu.be"], .glightbox',
    width: 900,
    autoplayVideos: true,
    slideEffect: 'fade',
});

// fade in logo on page load
const logo = document.querySelector('.custom-logo');
if (logo) {
    logo.classList.add('is-visible');
}
const navigation = document.querySelector('#mega-menu-wrap-header');
if (navigation) {
    navigation.classList.add('is-visible');
}